module.exports = __webpack_public_path__ + "assets/b105.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b105.png
// module id = 576
// module chunks = 0